import { Box } from '@gazin/ecommerce-ui'
import { RewardsPoints } from 'src/types/RewardsPoints'
import { Campaign } from 'src/util/enums/Campaign'
import LiveloProductCampaign from './campaigns/livelo'

export type ProductRewardsPointsProps = {
  campaign: RewardsPoints
  productValue: number
}

const CampaignsComponents: Record<
  Campaign,
  (props: ProductRewardsPointsProps) => JSX.Element
> = {
  [Campaign.LIVELO]: LiveloProductCampaign,
}

export default function ProductRewardsPoints(props: ProductRewardsPointsProps) {
  const CampaignComponent = CampaignsComponents[props.campaign.slug]

  return (
    <Box mb="1.5rem">
      <CampaignComponent {...props} />
    </Box>
  )
}
